// sort-key-value.pipe.ts
import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'sortKeyValue',
})
export class SortKeyValuePipe implements PipeTransform {
  transform(value: any, condition: { key: string }[] | string = 'asc'): any {
    if (!value || typeof value !== 'object') {
      return value;
    }

    // Handle the specific case where the input is an object with 'field', 'value', and 'checked'
    if (
      (Object.prototype.hasOwnProperty.call(value, 'field') ||
        Object.prototype.hasOwnProperty.call(value, 'varName')) &&
      Object.prototype.hasOwnProperty.call(value, 'value') &&
      Object.prototype.hasOwnProperty.call(value, 'checked')
    ) {
      value = {
        [value.field || value.varName]: value.value,
      };
    }

    let sortedArray;
    if (Array.isArray(condition)) {
      sortedArray = Object.entries(value).sort(([keyA], [keyB]) => {
        // Ensure 'fundDetails' always comes last
        if (keyA === 'fundDetails') return 1;
        if (keyB === 'fundDetails') return -1;

        const indexA = condition.findIndex(item => item.key === keyA);
        const indexB = condition.findIndex(item => item.key === keyB);

        // If a key is not found in condition, it will appear at the end
        if (indexA === -1 && indexB === -1) return 0;
        if (indexA === -1) return 1;
        if (indexB === -1) return -1;

        return indexA - indexB;
      });
    } else {
      sortedArray = Object.entries(value).sort(([keyA], [keyB]) => {
        return condition === 'asc'
          ? keyA.localeCompare(keyB)
          : keyB.localeCompare(keyA);
      });
    }

    return sortedArray.map(([key, val]) => ({ key, value: val }));
  }
}
